import "./ButtonNav.css";
import { ChevronRight } from "lucide-react";

export default function ButtonNav({
    title,
    icon,
    onClick,
    disabled = false,
}) {
    return (
        <button
            className="button-nav"
            onClick={onClick}
            disabled={disabled}
        >
            <div className="button-nav__left">
                <div className="button-nav__icon">
                    {typeof icon === "string" ? (
                        <img src={icon} alt="" />
                    ) : (
                        icon
                    )}
                </div>

                <span>{title}</span>
            </div>

            <div className="button-nav__arrow">
                <ChevronRight size={22} />
            </div>
        </button>
    );
}